import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-nav z-30 flex items-center justify-center fixed top-0 left-0 w-full border-b border-border bg-card h-20 print:hidden" }
const _hoisted_2 = { class: "flex items-center justify-center w-full px-6" }
const _hoisted_3 = { class: "cursor-pointer flex-1 text-left flex flex-row items-center" }
const _hoisted_4 = {
  class: "sm:border-l border-border pl-3 ml-3",
  href: "/"
}
const _hoisted_5 = {
  key: 0,
  class: "flex-1 flex justify-end items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "SendMailMessageTemplate", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "SendMailMessage", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "BirthdayScheduleCall", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "NotifierScheduleCall", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Sende DailyReminder", -1)
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = {
  key: 1,
  class: "absolute flex flex-col py-2 right-0 bg-card border border-border z-50 rounded-md"
}
const _hoisted_13 = { class: "flex px-8 gap-4" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "flex-1 flex flex-col justify-center h-12 whitespace-nowrap" }
const _hoisted_16 = { class: "font-bold text-xs" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex gap-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_21 = { class: "flex gap-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "Abmelden", -1)
const _hoisted_23 = { class: "flex flex-col bg-card max-w-sm w-full h-full border-r z-40" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_26 = { class: "flex flex-1 flex-col pt-4" }
const _hoisted_27 = { class: "flex flex-col flex-none" }
const _hoisted_28 = { class: "space-y-2 px-8" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "flex-1 ml-3 whitespace-nowrap" }
const _hoisted_31 = {
  key: 2,
  class: "absolute top-2 right-2"
}
const _hoisted_32 = { class: "absolute inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full -top-4 -right-4" }
const _hoisted_33 = { class: "flex flex-col flex-1 justify-end" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "space-y-2 px-8" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "flex-1 ml-3 whitespace-nowrap" }

import { useStore } from "vuex"
import { Ref, computed } from "@vue/reactivity"
import { RouteRecordNormalized, useRoute, useRouter } from "vue-router"

import { auth, firestore, functions } from "@/firebase"
import { signOut } from "firebase/auth"
import { mdiLogoutVariant, mdiMenu, mdiViewDashboard, mdiLogout, mdiEmail } from "@mdi/js"

import IconItem from "@/components/theme/icon-item.vue"
import AvatarItem from "@/components/theme/avatar-item.vue"
import LogoItem from "../theme/logo-item.vue"
import { Permission } from "@/classes/EmployeePermission"
import { httpsCallable } from "@firebase/functions"
import { onMounted, ref, watch } from "vue"
import { ObjectEstate } from "@/classes/ObjectEstate"
import { Customer, CustomerSource, CustomerStatus } from "@/classes/Customer"
import { collectionGroup, getDocs, query, where, doc, setDoc, addDoc, collection } from "@firebase/firestore"
import { endOfDay, startOfDay } from "date-fns"




export default /*#__PURE__*/_defineComponent({
  __name: 'app-navigation',
  setup(__props) {


const route = useRoute()
const router = useRouter()
const store = useStore()

const isCompanyAdmin = computed(() => {
    if (!store.state.auth.permission) {
        return false
    }

    return store.state.auth?.permission?.permissions?.includes(Permission.CompanyAdmin) || store.state.auth?.permission?.permissions?.includes(Permission.GlobalAdmin)
})


const isBetaTester = computed(() => {
    if (!store.state.auth.permission) {
        return false
    }

    return store.state.auth?.permission?.permissions?.includes(Permission.BetaTester)
})

watch(isCompanyAdmin, (newVal: boolean) => {
    if (newVal === true) {
        loadProfilePictureMenuRoutes()
    }
})

watch(isBetaTester, (newVal: boolean) => {
    if (newVal === true) {
        loadProfilePictureMenuRoutes()
    }
})


const logout = async () => {
    await signOut(auth)
    router.push("/login").catch()
}

const profileMenuVisible = ref(false)
const openRoute = (url: string) => {
    profileMenuVisible.value = false
    store.state.app.sidebarVisible = false
    router.push(url).catch()
}

const openSidebar = () => {
    store.state.app.sidebarVisible = true
}
const isSignedIn = computed(() => {
    return store.state.auth.isSignedIn
})

const employeeFullName = computed(() => {
    return `${store.state.auth?.profile?.firstName} ${store.state.auth?.profile?.lastName}`
})

const employeeEmail = computed(() => {
    return `${store.state.auth?.profile?.email}`
})

const clickProfilePicture = () => {
    // openRoute("/user-profile")
    profileMenuVisible.value = true
}

const profilePicture = computed(() => {
    if (!store.state.auth.isSignedIn) {
        return null
    }
    if (!store.state.auth.profile) {
        return null
    }
    return store.state.auth.profile.picture
})


const isGlobalAdmin = computed(() => {
    if (!store.state.auth.permission) {
        return false
    }

    return store.state.auth?.permission?.permissions?.includes(Permission.GlobalAdmin)
})

const isLocalHost = computed(() => {
    return window.location.href.startsWith("http://localhost:")
})


const todaysFollowUps = ref(0)
const loadTodaysFollowUps = async () => {
    const collectionRef = collectionGroup(firestore, "followup")
    const queryRef = query(
        collectionRef,
        where("financer", "==", store.state.auth.profile.sub),
        where("date", ">=", startOfDay(new Date())),
        where("date", "<=", endOfDay(new Date()))
    )
    const snapshot = await getDocs(queryRef)
    todaysFollowUps.value = snapshot.docs.length
}


const sideBarRoutes: Ref<RouteRecordNormalized[]> = ref([])
const loadSideBarRoutes = () => {
    for (const route of router.getRoutes().sort((a, b) => (a.meta.navBarOrder as number) - (b.meta.navBarOrder as number))) {
        if (route.meta.showInNavBar) {
            sideBarRoutes.value.push(route)
        }
    }

    sideBarRoutes.value.find(r => r.name === "requests")!.meta.quantity = computed(() => {
        return openAffiliates.value.length + objects.value.length
    })

    sideBarRoutes.value.find(r => r.name === "follow-ups")!.meta.quantity = computed(() => {
        return todaysFollowUps.value
    })
}

const profilePictureMenuRoutes: Ref<RouteRecordNormalized[]> = ref([])
const loadProfilePictureMenuRoutes = () => {

    profilePictureMenuRoutes.value = []
    for (const route of router.getRoutes().sort((a, b) => (a.meta.PPMOrder as number) - (b.meta.PPMOrder as number))) {
        if (route.meta.showInPPM) {
            if (route.meta.onlyCompanyAdmin) {
                if (isCompanyAdmin.value === true) {
                    profilePictureMenuRoutes.value.push(route)
                } else {
                    //
                }
            } else if (route.meta.onlyBetaTester) {
                if (isBetaTester.value === true) {
                    profilePictureMenuRoutes.value.push(route)
                } else {
                    //
                }
            } else {
                profilePictureMenuRoutes.value.push(route)
            }
        }
    }
}

const secondaryRoutes = [
    {
        title: "Abmelden",
        click: () => logout(),
        icon: mdiLogout,
        url: ""

    }
]

const sidebarClasses = computed(() => {
    const arrCss = [
        "h-full",
        "w-screen",
        "fixed",
        "z-50",
        "top-0",
        "left-0",
        "ease-in-out",
        "duration-1000",
        "lg:hidden"
    ]

    if (!store.state.app.sidebarVisible) {
        arrCss.push("hidden")
    }

    return arrCss
})

const closeSidebar = () => {
    store.state.app.sidebarVisible = false
}


const currentRoutePath = computed(() => {
    return route.path
})

const callBirthdaySchedule = async () => {
    const callBirthdaySchedule = httpsCallable<Record<string, unknown>, Record<string, unknown>>(functions, "callBirthdaySchedule")
    await callBirthdaySchedule()
}

const callNotifierSchedule = async () => {
    const callNotifierSchedule = httpsCallable<Record<string, unknown>, Record<string, unknown>>(functions, "callNotifierSchedule")
    await callNotifierSchedule()
}

const sendDailyReminder = async () => {
    const callReminderCustomerPortal = httpsCallable<Record<string, unknown>, Record<string, unknown>>(functions, "callReminderCustomerPortal")
    await callReminderCustomerPortal()
}


const openAffiliates = computed(() => {
    return store.state.customer.customers.filter((c: Customer) => c.source == CustomerSource.Affiliate && c.state == CustomerStatus.Offen)
})

const objects = computed(() => {
    const items: ObjectEstate[] = []
    for (const item of store.state.object.objects as ObjectEstate[]) {
        const address = `${item.address.street} ${item.address.number} ${item.address.postcode} ${item.address.location}`
        if (address.toLowerCase().indexOf("")) {
            items.push(item)
        }
    }
    items.sort((a, b) => {
        if (a.address.postcode > b.address.postcode) {
            return 1
        } else if (a.address.postcode < b.address.postcode) {
            return -1
        }
        if (a.address.location > b.address.location) {
            return 1
        } else if (a.address.location < b.address.location) {
            return -1
        }
        if (a.address.street > b.address.street) {
            return 1
        } else if (a.address.street < b.address.street) {
            return -1
        }
        if (a.address.number > b.address.number) {
            return 1
        } else if (a.address.number < b.address.number) {
            return -1
        }
        if (a.address.floor > b.address.floor) {
            return 1
        } else if (a.address.floor < b.address.floor) {
            return -1
        }
        if (a.address.room > b.address.room) {
            return 1
        } else if (a.address.room < b.address.room) {
            return -1
        }
        return 0
    })
    return items
})

const SendMailMessage = async () => {
    //
    console.log("ok")
    await addDoc(collection(firestore, "mailNew"), {
        _companyId: "baufi-team",
        _recipientId: "BLeTEZdqYwYWGVCbEFJH",
        // _recipientId: "cva3GDX73wmNXCTB2LCY",
        _senderId: "",
        forceBLServer: true,
        message: {
            html: `hi
                wie gehts?
                mir gehts gut :)
                Danke!
                lol
                
                123

                Grüße
                Dennis`,
            subject: "SendMailMessageCustomServer"
        },
        recipientType: "Customer"
    })
}

const SendMailMessageTemplate = async () => {
    await addDoc(collection(firestore, "mailNew"), {
        _companyId: "baufi-team",
        _recipientId: "BLeTEZdqYwYWGVCbEFJH",
        //_recipientId: "cva3GDX73wmNXCTB2LCY",
        _senderId: "zdv2DrQPKhYhJtCWgqQVdPopQbh2",
        template: {
            name: "cp_activated_new_user",
            data: [
                {
                    key: "c_lastName",
                    value: "Tester"
                },
                {
                    key: "e_firstName",
                    value: "Calvinovic"
                }
            ]
        },
        recipientType: "Customer"
    })
}


onMounted(async () => {
    loadSideBarRoutes()
    loadProfilePictureMenuRoutes()
    await store.dispatch("attachRequestObjects")
    await store.dispatch("attachCustomers")
    await loadTodaysFollowUps()

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(IconItem, {
            class: "flex lg:hidden",
            path: _unref(mdiMenu),
            onClick: openSidebar
          }, null, 8, ["path"]),
          _createVNode(LogoItem, {
            class: "h-6 hidden lg:flex",
            type: "logo"
          }),
          _createElementVNode("a", _hoisted_4, _toDisplayString(_unref(store).state.company?.company?.name), 1)
        ]),
        (_unref(isSignedIn))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_unref(isGlobalAdmin) && _unref(isLocalHost))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: SendMailMessageTemplate,
                    class: "text-sm cursor-pointer hover:opacity-50 transition-opacity mr-4 hidden lg:flex"
                  }, [
                    _createVNode(IconItem, {
                      path: _unref(mdiEmail),
                      size: 16,
                      class: "mr-2"
                    }, null, 8, ["path"]),
                    _hoisted_6
                  ]))
                : _createCommentVNode("", true),
              (_unref(isGlobalAdmin) && _unref(isLocalHost))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: SendMailMessage,
                    class: "text-sm cursor-pointer hover:opacity-50 transition-opacity mr-4 hidden lg:flex"
                  }, [
                    _createVNode(IconItem, {
                      path: _unref(mdiEmail),
                      size: 16,
                      class: "mr-2"
                    }, null, 8, ["path"]),
                    _hoisted_7
                  ]))
                : _createCommentVNode("", true),
              (_unref(isGlobalAdmin) && _unref(isLocalHost))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    onClick: callBirthdaySchedule,
                    class: "text-sm cursor-pointer hover:opacity-50 transition-opacity mr-4 hidden lg:flex"
                  }, [
                    _createVNode(IconItem, {
                      path: _unref(mdiEmail),
                      size: 16,
                      class: "mr-2"
                    }, null, 8, ["path"]),
                    _hoisted_8
                  ]))
                : _createCommentVNode("", true),
              (_unref(isGlobalAdmin) && _unref(isLocalHost))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    onClick: callNotifierSchedule,
                    class: "text-sm cursor-pointer hover:opacity-50 transition-opacity mr-4 hidden lg:flex"
                  }, [
                    _createVNode(IconItem, {
                      path: _unref(mdiEmail),
                      size: 16,
                      class: "mr-2"
                    }, null, 8, ["path"]),
                    _hoisted_9
                  ]))
                : _createCommentVNode("", true),
              (_unref(isGlobalAdmin) && _unref(isLocalHost))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 4,
                    onClick: sendDailyReminder,
                    class: "text-sm cursor-pointer hover:opacity-50 transition-opacity mr-4 hidden lg:flex"
                  }, [
                    _createVNode(IconItem, {
                      path: _unref(mdiEmail),
                      size: 16,
                      class: "mr-2"
                    }, null, 8, ["path"]),
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(AvatarItem, {
                  src: _unref(profilePicture),
                  onClick: clickProfilePicture,
                  class: "cursor-pointer h-12 w-12 border border-black"
                }, null, 8, ["src"]),
                (profileMenuVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "fixed inset-0 bg-black bg-opacity-25 z-40",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (profileMenuVisible.value = false))
                    }))
                  : _createCommentVNode("", true),
                (profileMenuVisible.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(AvatarItem, {
                            src: _unref(profilePicture),
                            class: "cursor-pointer h-12 w-12 border border-black"
                          }, null, 8, ["src"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("p", null, _toDisplayString(_unref(employeeFullName)), 1),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(employeeEmail)), 1)
                        ])
                      ]),
                      _hoisted_17,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profilePictureMenuRoutes.value, (route) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: route.path,
                          class: "flex flex-col justify-center h-12 px-8 whitespace-nowrap hover:bg-primary-hover cursor-pointer",
                          onClick: ($event: any) => (openRoute(route.path))
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(IconItem, {
                              path: (route.meta.icon as string)
                            }, null, 8, ["path"]),
                            _createElementVNode("p", {
                              class: _normalizeClass([_unref(currentRoutePath) === route.path ? 'underline' : ''])
                            }, _toDisplayString(route.meta.title), 3)
                          ])
                        ], 8, _hoisted_18))
                      }), 128)),
                      _hoisted_20,
                      _createElementVNode("div", {
                        class: "flex flex-col justify-center h-12 px-8 whitespace-nowrap hover:bg-primary-hover cursor-pointer",
                        onClick: logout
                      }, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(IconItem, { path: _unref(mdiLogoutVariant) }, null, 8, ["path"]),
                          _hoisted_22
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(sidebarClasses))
    }, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(LogoItem, {
            class: "w-full object-cover",
            type: "logo"
          })
        ]),
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("ul", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sideBarRoutes.value, (route) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "cursor-pointer",
                  key: route.path
                }, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (openRoute(route.path)),
                    class: _normalizeClass(["relative flex items-center p-2 text-base font-normal rounded-lg hover:bg-primary-normal", _unref(currentRoutePath) === route.path ? 'bg-primary-normal text-white fill-white' : 'bg-gray-200 text-black fill-black'])
                  }, [
                    (route.meta.icon)
                      ? (_openBlock(), _createBlock(IconItem, {
                          key: 0,
                          path: (route.meta.icon as string)
                        }, null, 8, ["path"]))
                      : (_openBlock(), _createBlock(IconItem, {
                          key: 1,
                          path: _unref(mdiViewDashboard)
                        }, null, 8, ["path"])),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(route.meta.title), 1),
                    ((route.meta.quantity as number) > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(route.meta.quantity), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_29)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("ul", _hoisted_35, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(secondaryRoutes, (route) => {
                  return _createElementVNode("li", {
                    class: "cursor-pointer",
                    key: route.url
                  }, [
                    _createElementVNode("a", {
                      onClick: route.click,
                      class: _normalizeClass(["flex items-center p-2 text-base font-normal rounded-lg text-black hover:bg-primary-normal", _unref(currentRoutePath) == route.url ? 'bg-primary-normal' : ''])
                    }, [
                      (route.icon)
                        ? (_openBlock(), _createBlock(IconItem, {
                            key: 0,
                            path: route.icon
                          }, null, 8, ["path"]))
                        : (_openBlock(), _createBlock(IconItem, {
                            key: 1,
                            path: _unref(mdiViewDashboard)
                          }, null, 8, ["path"])),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(route.title), 1)
                    ], 10, _hoisted_36)
                  ])
                }), 64))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "fixed left-0 top-0 w-full h-full -z-10 bg-black opacity-80",
        onClick: closeSidebar
      })
    ], 2)
  ]))
}
}

})